import React from 'react';

import {SettingIndentedRow} from '../components/SettingIndentedRow';
import {MediaSetting} from './types';

export const Subsettings = ({subsettings}: {subsettings: MediaSetting[]}) => {
  const renderedSubsettings = subsettings
    .map(({component: SubSettingComponent}, index) => {
      const content = <SubSettingComponent />;
      return content ? (
        <SettingIndentedRow className="flex flex-col gap-8 first:pt-0">
          <div className="pl-14" key={index}>
            {content}
          </div>
        </SettingIndentedRow>
      ) : null;
    })
    .filter(Boolean);

  if (renderedSubsettings.length === 0) {
    return null;
  }

  return <>{renderedSubsettings}</>;
};
